import React from 'react'
import { navigateTo } from 'gatsby-link'
import Modal from 'react-responsive-modal'
import { withCookies, Cookies, CookiesProvider } from 'react-cookie'
import { instanceOf } from 'prop-types'
import gridImage1 from '../images/a_frame.jpg'
import gridImage2 from '../images/welcome_sheet.jpg'
import gridImage3 from '../images/friendship_house.jpg'
import gridImage4 from '../images/students_flyers.jpg'
import jj from '../images/jj.jpg'
import sgp from '../images/SGP-logo.png'
import ccs from '../images/CCS-logo.png'
import fiec from '../images/FIEC-logo.png'
// import Christmas2019 from '../images/Christmas2019.jpg'
import bigDayOut from '../images/Big-Day-Out-2018.jpg'

import sundayBroadcast from '../images/broadcast-3-may.jpg'

import ce2020 from '../images/ce2020.jpg'

import spinicer from '../images/Grid_images_09164.jpg'

import Link from '../components/Link'

import Header from '../components/Header'

class AnnouncementModal extends React.Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  }

  state = {
    open: false,
  }

  onOpenModal = () => {
    this.setState({ open: true })
  }

  onCloseModal = () => {
    this.setState({ open: false })
    const { cookies } = this.props
    cookies.set('BIGDAYOUT2019', true, { path: '/' })
  }

  componentDidMount() {
    const { cookies } = this.props
    const eventDate = new Date('2019-06-09')
    const today = new Date()
    if (today <= eventDate && !cookies.get('BIGDAYOUT2019')) {
      this.setState({ open: true })
    }
  }

  render() {
    return (
      <Modal
        open={this.state.open}
        closeOnOverlayClick={true}
        center
        onClose={this.onCloseModal}
      >
        <div style={{ maxWidth: '100%', textAlign: 'center', padding: '1em' }}>
          <h2>BIG DAY OUT 2019</h2>
          <br />
          <p>
            <strong>This coming Sunday is our Big Day Out! </strong>
          </p>
          <br />
          <p>
            <strong>
              There will be no gathering at Friendship House this Sunday (9 June
              2019).
            </strong>
          </p>
          <br />
          <p>
            If you've missed out on the details please email: &nbsp;
            <a
              className="responsive-text"
              href="mailto=jon@cornerstonechurchportsmouth.org"
            >
              jon@cornerstonechurchportsmouth.org
            </a>
          </p>
          <br />
          <img style={{ width: '50%' }} src={bigDayOut} />
        </div>
      </Modal>
    )
  }
}

const AnnouncementModalContainer = withCookies(AnnouncementModal)

const ChristmasAd = ({ show = false }) => (
  <section
    id="special"
    className="special"
    style={{
      borderBottom: '3px dashed #ccc',
      display: show ? 'block' : 'none',
    }}
  >
    <div className="container">
      <div className="row">
        <div className="col-md-3 col-md-offset-1">
          <a href="/christmascraft">
            <img style={{ width: '100%' }} src={Christmas2019} />
          </a>
        </div>
        <div className="col-md-6">
          <h3>Sunday 22nd December</h3>
          <p>All age gathering. 10.30am, Friendship House. </p>

          <br />
          <h3>Christmas Day &amp; December 29th.</h3>
          <p>No gathering</p>
        </div>
      </div>
    </div>
  </section>
)

const MenuLink = (props) => (
  <div
    style={{
      padding: '0.8em',
      textAlign: 'center',
      fontSize: '1.2em',
    }}
  >
    <Link {...props} />
  </div>
)

const MenuButton = (props) => (
  <div
    className="visible-xs"
    style={{
      position: 'absolute',
      top: '78%',
      textAlign: 'center',
      width: '100%',
      padding: '0 10%',
    }}
  >
    <div
      style={{
        margin: '0 auto',
        backgroundColor: 'white',
        padding: '.4em .6em',
        borderRadius: '30px',
        boxShadow: '0 4px 8px 0 rgba(0,0,0,0.12), 0 2px 4px 0 rgba(0,0,0,0.08)',
        borderBottom: '2px solid #cacaca',
        textAlign: 'center',
        fontSize: '1em',
      }}
    >
      <Link {...props} style={{ textDecoration: 'none' }} />
    </div>
  </div>
)

const WatchLabel = () => {
  const today = new Date()
  const isSunday = today.getDay() == 0 && today.getHours() < 12

  return (
    <span style={{}}>
      {isSunday ? (
        <span
          style={{
            alignItems: 'center',
            display: 'flex',
            textTransform: 'uppercase',
            fontWeight: 'bold',
          }}
          className="pulsate"
        >
          <span
            style={{
              fontSize: '2em',
              paddding: 0,
              margin: 0,
              lineHeight: 0,
              paddingRight: '.25em',
            }}
          >
            &#183;
          </span>{' '}
          Watch live
        </span>
      ) : (
        'Watch latest'
      )}
    </span>
  )
}

const IndexPage = () => (
  <div>
    <Header />
    <section>
      <div
        className="container"
        style={{ paddingTop: 0, paddingBottom: '40px' }}
      >
        <div className="row">
          <div
            className="col-md-12"
            style={{
              border: '1px solid #fefefe',
              backgroundColor: '#fefefe',
              textAlign: 'left',
            }}
          >
            <h3>Covid-19 update</h3>
            <p>
              For the next few weeks we are unable to meet as normal, but there
              will be a video broadcast on Sundays at 10.30am.
            </p>
            <div>
              <p>
                Need prayer or assistance? &nbsp;
                <Link
                  href="https://nathan341.typeform.com/to/TIqzun"
                  target="_blank"
                >
                  Contact us here
                </Link>
              </p>
            </div>

            <div className="fp-row">
              <div
                className="fp-col"
                style={{
                  height: '200px',
                  border: '1px solid #f7f6f6',
                  borderRadius: '4px',
                  boxShadow:
                    '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                  // padding: '2em',
                  justifyContent: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <a className="opacity-hover" href="christianity-explored">
                  <img
                    width="100%"
                    height="100%"
                    src={ce2020}
                    style={{ display: 'block', borderRadius: '4px' }}
                  />
                </a>
                {/* <h3 style={{ lineHeight: '1.3em' }}>
                  Need prayer or assistance?
                </h3>
                <p>
                  <Link
                    href="https://nathan341.typeform.com/to/TIqzun"
                    target="_blank"
                  >
                    Contact us here
                  </Link>
                </p> */}
              </div>

              <div
                className="fp-col fp-col-middle"
                style={{
                  height: '200px',
                  border: '1px solid #f7f6f6',
                  borderRadius: '4px',
                  boxShadow:
                    '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                  // padding: '2em',
                  justifyContent: 'center',
                  display: 'flex',
                  flexDirection: 'column',

                  backgroundColor: '#053f5c',
                  color: 'white',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <a
                  className="opacity-hover"
                  href="https://www.cornerstonechurchportsmouth.org/live"
                  target="_blank"
                >
                  <img
                    width="100%"
                    height="100%"
                    src={sundayBroadcast}
                    style={{ display: 'block', borderRadius: '4px' }}
                  />
                  <div
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      backgroundColor: '#351c32',
                      padding: '1em',
                      borderRadius: '4px',
                      color: 'white',
                    }}
                  >
                    <WatchLabel />
                  </div>
                </a>
              </div>

              <div
                className="fp-col"
                style={{
                  flex: '33%',
                  padding: '2em',
                  border: '1px solid #f7f6f6',
                  borderRadius: '4px',
                  boxShadow:
                    '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                }}
              >
                <h3>Latest blog</h3>
                <p>
                  <Link href="/blog">Daily Debts</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div className="hero container-fluid ">
      <div className="row">
        <div className="col-md-3 col-sm-3 col-xs-6">
          <img
            className="first-image  img-responsive"
            style={{ width: '100%' }}
            src={gridImage1}
          />
        </div>
        <div className="col-md-3 col-sm-3 col-xs-6">
          <a href="#sundays">
            <img className="img-responsive" src={gridImage2} />
          </a>

          <MenuButton href="#sundays">What to expect</MenuButton>
          <div className="hidden-xs">
            <MenuLink href="#sundays">What to expect</MenuLink>
          </div>
        </div>
        <div className="col-md-3 col-sm-3 col-xs-6">
          <a href="#location">
            <img className="img-responsive" src={gridImage3} />
          </a>
          <MenuButton href="#location">Location &amp; Times</MenuButton>
          <div className="hidden-xs">
            <MenuLink href="#location">Location &amp; Times</MenuLink>
          </div>
        </div>
        <div className="col-md-3 col-sm-3 col-xs-6">
          <a href="#" onClick={() => navigateTo('/students')}>
            <img className="img-responsive" src={gridImage4} />
          </a>
          <MenuButton href="/students">Students</MenuButton>
          <div className="hidden-xs">
            <MenuLink href="/students">Students</MenuLink>
          </div>
        </div>
      </div>
    </div>
    {/* <ChristmasAd show={Date.now() < new Date('2020-01-01')} /> */}

    <section id="welcome" className="welcome">
      <div className="container">
        <div className="row">
          <div className="p-big" className="col-md-8">
            <h1 style={{ marginBottom: '0.5em' }}>Welcome</h1>
            <p style={{ marginBottom: '0.6em' }}>
              We are a church that wants to help people come to know Jesus more.
            </p>
            <p>
              We&#39;re confident that as people come to know Jesus, they
              won&#39;t be disappointed.
            </p>
          </div>
          <div className="p-big" className="col-md-4">
            {/* <div>
              <h3>Freshers 2019</h3>
              <p>Moving to Portsmouth to study?</p>
              <Link href="/students" style={{ fontSize: '1.2em' }}>
                Let us know you're coming
              </Link>
            </div> */}
            {/* <div style={{ display: 'flex' }}>
              <div
                style={{
                  border: '1px solid #ddd',
                  borderRadius: '.25em',
                  padding: '0.25em',
                }}
              >
                <a
                  target="_blank"
                  href="https://www.facebook.com/events/439699276578187/"
                >
                  <img
                    style={{ width: '15em' }}
                    src={eveningWithLinvoyPrimus}
                  />
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
    <section id="location" className="grey">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h1>Location &amp; Times</h1>
            <p style={{ lineHeight: '1.7em' }}>
              Friendship House, Elm Grove, PO5 1JT
              <br />
              10:30am (drinks from 10:15am)
            </p>

            <p style={{ marginTop: '1.5em', marginBottom: '2em' }}>
              <Link href="#sundays">What to expect</Link>
            </p>

            <div className="btn-links" />
          </div>
          <div className="col-md-6">
            <div className="google-maps">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d20177.92653500724!2d-1.093095060649006!3d50.78964548183031!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48745d980b7d1579%3A0x4b354ae148906e2c!2sCornerstone+Church+Portsmouth!5e0!3m2!1sen!2suk!4v1557065373255!5m2!1sen!2suk"
                width="470"
                height="400"
                frameBorder="0"
                style={{ border: '0' }}
                allowFullScreen={true}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="sundays" className="sundays blue">
      <div className="container">
        <div className="row">
          <div className="col-md-6 mobile-box grey">
            <h1>Sundays - What to expect</h1>

            <p>
              Cornerstone meets each Sunday 10:30am with drinks and cake from
              10:15am.
            </p>
            <p style={{ marginTop: '1.5em', marginBottom: '2em' }}>
              <Link href="#location">Location &amp; Times</Link>
              <Link style={{ marginLeft: '1em' }} href="/talks">
                Talk Library
              </Link>
            </p>
            <iframe
              className=" visible-xs visible-sm"
              style={{ border: 0, width: '100%', height: 'auto' }}
              src="https://player.vimeo.com/video/364898791"
              width="640"
              height="480"
              frameborder="0"
              allow="autoplay; fullscreen"
              allowFullScreen={true}
            />
            <h4>For children </h4>
            <p style={{ fontSize: '1em' }}>
              We love children at Cornerstone! Each Sunday there will be a
              crèche and a group for primary school aged children. Most often
              the children consider the same section of the bible that the
              adults will be looking at. All the children’s workers are Church
              Partners and DBS checked.
            </p>
            <h4>You're very welcome</h4>
            <p style={{ fontSize: '1em' }}>
              Please do come and join us, we’d love to welcome you. You'll meet
              people with different backgrounds and stories. Many of those
              you'll meet have come to know the amazing good news of Jesus.
            </p>
          </div>
          <div className="col-md-6 col-sm-12">
            <br />
            <br />
            <br />
            <br />
            <br />
            <div
              style={{
                backgroundColor: 'white',
                color: '#333',
                opacity: 0.8,
                paddingLeft: 8,
              }}
            />

            <iframe
              className="img-responsive hidden-xs hidden-sm"
              style={{ border: 0, width: '100%', height: '300px' }}
              src="https://player.vimeo.com/video/364898791"
              width="640"
              height="480"
              frameborder="0"
              allow="autoplay; fullscreen"
              allowFullScreen={true}
            />
          </div>
        </div>
      </div>
    </section>

    <section id="contact" className="blue">
      <div className="container">
        <div className="row">
          <div className="col-md-6 text">
            <h2>Moving to Portsmouth?</h2>
            <p>
              If you know and trust Jesus and are moving to Portsmouth to study,
              work or live we would love you to join us at Cornerstone.
            </p>
            <h2>Studying in Portsmouth?</h2>
            <p>
              Find out more about what's on for students&nbsp;
              <Link dark href="/students.html">
                here
              </Link>
            </p>
            <h2>Just wanting to know more?</h2>
            <p>
              Alternatively, maybe you don’t know Jesus at all – well we would
              love to meet you too. Whatever your background and knowledge of
              Jesus we want to welcome you.
            </p>
            <p>
              At Cornerstone, we simply want everyone to know Jesus more. We are
              confident that as people do that – they won’t be disappointed.
            </p>
          </div>
          <div className="col-md-6">
            <div className="mobile-box grey" style={{ overflow: 'auto' }}>
              <h2>Get in touch</h2>
              <p>
                If you have any questions please feel free to get in contact:
                <br /> <br />
                <Link href="mailto:info@cornerstonechurchportsmouth.org">
                  info@cornerstonechurchportsmouth.org
                </Link>
              </p>
            </div>
            <iframe
              className="img-responsive"
              style={{ width: '100%', height: '300px', marginTop: '20px' }}
              src="https://player.vimeo.com/video/174017742?title=0&byline=0&portrait=0"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
    <section className="who-we-are grey">
      <div className="container">
        <div className="row">
          <div className="col-md-6 text">
            <h2>Who We Are</h2>
            <p>
              Cornerstone is part of the FIEC network of churches. The church
              was established in 2016 with the help of Christ Church
              Southampton.
            </p>
            <p>
              We are convinced that Jesus is good news and want all people to
              know him more. We believe that the Bible is ultimately all about
              Jesus and so are committed to seeking to grasp all of its message.
              Each Sunday we focus on a different section of the Bible –
              normally as we work through a particular Bible book.{' '}
            </p>
            <p>
              If you’ve been a Christian for some time or if the good news of
              Jesus is completely new to you – we believe the Bible will help
              you to grow, explore and find questions answered.
            </p>
          </div>
          <div className="col-md-6 col-md-offset-6 hidden-xs image">
            <div
              className="image-holder right"
              style={{ backgroundImage: `url(${spinicer})` }}
            />
          </div>
        </div>
      </div>
    </section>

    <section className="who-we-are">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text">
            <h2>Who's Who</h2>
            <div className="row">
              <div className="col-md-6">
                <h3>Jon Shulver</h3>
                <p>
                  Jon Shulver lives in Southsea and is the pastor of Cornerstone
                  Church. He is married to Jo and they have two young children.
                </p>
                <p>
                  Jon has previously worked as the Director of Contagious Bible
                  Ministries - helping young people discover what the Bible
                  says. He trained at Oak Hill College.
                </p>
              </div>
              <div className="col-md-6">
                <div>
                  <img
                    src={jj}
                    style={{
                      width: '100%',
                      boxShadow:
                        '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="row" style={{ marginTop: '3em' }}>
              <div className="col-md-6">
                <h3>Tom Beaumont</h3>
                <p>
                  Tom Beaumont serves as an Elder alongside Jon. Tom is married
                  to Sarah and teaches in a local secondary school.
                </p>
              </div>
            </div>

            <div className="row" style={{ marginTop: '3em' }}>
              <div className="col-md-6">
                <h3>Rob Ross</h3>
                <p>
                  Rob Ross joined Cornerstone as a Ministry Trainee in 2018. He
                  is particularly involved in student ministry and trains one a
                  day a week on the South Central Ministry Training Course.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="supporters">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h2>Cornerstone Church Portsmouth is in partnership with:</h2>
            <div className="content row">
              <div className="col-md-4 supporter">
                <a
                  href="http://www.solentgospelpartnership.org.uk"
                  target="blank"
                >
                  <img src={sgp} height="50" />
                </a>
                <a
                  href="http://www.solentgospelpartnership.org.uk/"
                  target="blank"
                >
                  <h3>The Solent Gospel Partnership</h3>
                </a>
                <p>A grouping of likeminded churches in the region.</p>
              </div>
              <div className="col-md-4 supporter">
                <a href="https://fiec.org.uk" target="blank">
                  <img src={fiec} height="50" />
                </a>
                <a href="https://fiec.org.uk" target="blank">
                  <h3 className="hidden-xs">The FIEC</h3>
                </a>
                <p>A network of churches across the UK.</p>
              </div>
              <div className="col-md-4 supporter">
                <a href="http://christchurchsouthampton.org.uk" target="blank">
                  <img src={ccs} height="50" />
                </a>
                <a href="http://christchurchsouthampton.org.uk" target="blank">
                  <h3 className="hidden-xs">Christ Church Southampton</h3>
                </a>
                <p>A growing church keen to plant new churches.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <CookiesProvider>
      <AnnouncementModalContainer />
    </CookiesProvider>
    <section className="footer">
      <div className="container">
        <div className="row">
          <h2>Any questions?</h2>
          <p style={{ overflow: 'auto' }}>
            Please feel free to get in contact via: &nbsp;
            <Link href="mailto:info@cornerstonechurchportsmouth.org">
              info@cornerstonechurchportsmouth.org
            </Link>
          </p>
        </div>
      </div>
    </section>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js